<template>
  <portal to="modal-target-goal-details">
    <el-dialog
      :visible.sync="dialogVisible"
      :title="title">
      <slot></slot>
      <SortableList
        lockAxis="y"
        v-model="itemList"
        :useDragHandle="false">
        <SortableItem v-for="(item, index) in itemList"
          :index="index"
          :key="item.id"
          :item="item"/>
      </SortableList>
      <pre v-if="SHOW_DEBUG">{{itemList}}</pre>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="onSave">OK</el-button>
      </span>
    </el-dialog>
  </portal>
</template>

<script>
import { ContainerMixin, ElementMixin, HandleDirective } from 'vue-slicksort';

const SortableList = {
  mixins: [ContainerMixin],
  template: `
    <ul class="prio-list">
      <slot />
    </ul>
  `
};

const SortableItem = {
  mixins: [ElementMixin],
  directives: { handle: HandleDirective },
  props: ['item'],
  template: `
    <li class="prio-list-item">
      <span v-handle class="handle"></span>
      <span :style="{color: item.color, fontWeight: 'bold', fontFamily: 'Avenir'}">{{item.name}}</span>
    </li>
  `
};

export default {
  props: {
    title: { default: 'Set priorities by sorting' }
  },
  data: () => ({
    dialogVisible: false,
    itemList: [],
  }),
  methods: {
    open( list ) {
      this.itemList = list; // TODO: Copy?
      this.dialogVisible = true;
    },
    onSave() {
      this.$emit('save', this.itemList)
      this.dialogVisible = false;
    }
  },
  components: {
    SortableList,
    SortableItem,
  }
}
</script>

<style>
/* handle + list */
body > .prio-list-item {
  z-index: 9999;
}
.handle {
  display: block;
  width: 18px;
  height: 18px;
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><path d="M0 7.5v5h50v-5H0zm0 15v5h50v-5H0zm0 15v5h50v-5H0z" color="%23000"/></svg>');
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.25;
  margin-right: 20px;
  cursor: row-resize;
}
.prio-list-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px;
  background-color: #fff;
  border-bottom: 1px solid #efefef;
  box-sizing: border-box;
  user-select: none;
  color: #333;
  font-weight: 400;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.25));
  margin-top: 5px;
}
.prio-list {
  /* max-height: 80vh; */
  margin: 0 auto;
  padding: 1em;
  overflow: auto;
  background-color: #f3f3f3;
  /* border: 1px solid #efefef; */
}
</style>
